"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _overview = _interopRequireDefault(require("../overview"));

var _axios = _interopRequireDefault(require("axios"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _EmptyPage = _interopRequireDefault(require("@insided/deprecated-preact-components/empty-page/EmptyPage"));

var _UserCell = _interopRequireDefault(require("../overview/cells/UserCell"));

var _StatusCell = _interopRequireDefault(require("../overview/cells/StatusCell"));

var _DateCell = _interopRequireDefault(require("../overview/cells/DateCell"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _SimpleFilterSelector = _interopRequireDefault(require("../overview/filters/SimpleFilterSelector"));

var _RemoveCampaignAction = _interopRequireDefault(require("./components/RemoveCampaignAction"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _utils = require("./utils");

var _pluralize = _interopRequireDefault(require("@insided/control/utils/pluralize"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NumberCell = function NumberCell(metricKey) {
  return function (_ref) {
    var metrics = _ref.metrics;

    if (metrics && metricKey !== 'sent_count' && metrics.sent_count > 0) {
      return (0, _preact.h)(_Tooltip.default, {
        position: "center",
        trigger: (0, _preact.h)("span", null, "".concat(parseFloat((metrics[metricKey] / metrics.sent_count * 100).toFixed(1)), "%")),
        tooltipMessage: "".concat(metrics[metricKey], " ").concat(_utils.TOOLTIP_MESSAGE[metricKey]),
        top: 22
      });
    }

    return (0, _preact.h)("span", null, metrics ? metrics[metricKey] : '-');
  };
};

var LastSentCell = function LastSentCell(_ref2) {
  var metrics = _ref2.metrics;
  var lastSent = metrics ? metrics.last_sent : '-';
  return (0, _DateCell.default)('lastSent', true, true)({
    lastSent: lastSent,
    status: ''
  });
};

var ONE_DAY = 24 * 60 * 60;

function ExpireLabel(_ref3) {
  var expiresAt = _ref3.expiresAt,
      status = _ref3.status;

  if (!expiresAt || status.toLowerCase() === 'archived') {
    return null;
  }

  var now = new Date().getTime();
  var daysLeft = Math.round((expiresAt - now / 1000) / ONE_DAY);

  if (daysLeft > 0 && daysLeft <= 30) {
    return (0, _preact.h)("span", {
      className: "campaign-expiry-date"
    }, (0, _pluralize.default)(daysLeft, 'DAY', 'DAYS'), " LEFT");
  }

  return null;
}

function getColumns() {
  return [{
    header: 'Email title',
    accessor: 'title',
    cell: function cell(_ref4) {
      var title = _ref4.title,
          url = _ref4.url,
          expiresAt = _ref4.expiresAt,
          status = _ref4.status;
      return (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(window.location.origin + url),
        className: "qa-title-link campaign-title",
        "data-track-type": "click",
        "data-element-name": "An email campaign link"
      }, title, (0, _preact.h)(ExpireLabel, {
        expiresAt: expiresAt,
        status: status
      }));
    },
    size: 'l',
    isFixed: true
  }, {
    header: 'Email Type',
    accessor: 'campaignType',
    cell: function cell(_ref5) {
      var automated = _ref5.automated;
      return (0, _preact.h)("span", null, automated ? 'Automated' : 'One-off');
    }
  }, {
    header: 'Creator',
    accessor: 'sender',
    cell: (0, _UserCell.default)('sender')
  }, {
    header: 'Status',
    accessor: 'status',
    cell: (0, _StatusCell.default)(),
    size: 's'
  }, {
    header: 'Sent',
    accessor: 'sent_count',
    size: 'xs-right',
    cell: NumberCell('sent_count')
  }, {
    header: 'Delivered',
    accessor: 'delivered_count',
    size: 'xs-right',
    cell: NumberCell('delivered_count')
  }, {
    header: 'Opened',
    accessor: 'opened_count',
    size: 'xs-right',
    cell: NumberCell('opened_count')
  }, {
    header: 'Clicked',
    accessor: 'clicked_count',
    size: 'xs-right',
    cell: NumberCell('clicked_count')
  }, {
    header: 'Spam',
    accessor: 'spam_count',
    size: 'xs-right',
    cell: NumberCell('spam_count')
  }, {
    header: 'Unsubscribed',
    accessor: 'unsubscribed_count',
    size: 's right',
    cell: NumberCell('unsubscribed_count')
  }, {
    header: 'Last sent on',
    accessor: 'last_sent',
    cell: LastSentCell
  }];
}

var getFilters = function getFilters() {
  return [_SimpleFilterSelector.default.create({
    id: 'status',
    name: 'Status',
    items: [{
      id: 'draft',
      name: 'Draft',
      value: 'draft'
    }, {
      id: 'scheduled',
      name: 'Scheduled',
      value: 'scheduled'
    }, {
      id: 'sending',
      name: 'Sending',
      value: 'sending'
    }, {
      id: 'completed',
      name: 'Completed',
      value: 'completed'
    }, {
      id: 'archived',
      name: 'Archived',
      value: 'archived'
    }, {
      id: 'active',
      name: 'Active',
      value: 'active'
    }]
  })];
};

var EmailCampaignOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EmailCampaignOverview, _Component);

  var _super = _createSuper(EmailCampaignOverview);

  function EmailCampaignOverview() {
    var _this;

    (0, _classCallCheck2.default)(this, EmailCampaignOverview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      hasExpiringCampaign: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasExpiringCampaign", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clientSideFilter", function (data, filters) {
      var _filters$status;

      var filteredData = data;
      var hasExpiringCampaign = false;
      var now = new Date().getTime() / 1000;
      filteredData.forEach(function (row) {
        if (!hasExpiringCampaign && row.expiresAt && row.status.toLowerCase() !== 'archived') {
          var daysLeft = Math.round((row.expiresAt - now) / ONE_DAY);

          if (daysLeft > 0 && daysLeft <= 30) {
            hasExpiringCampaign = true;
          }
        }
      });

      _this.setState({
        hasExpiringCampaign: hasExpiringCampaign
      });

      if (((_filters$status = filters.status) === null || _filters$status === void 0 ? void 0 : _filters$status.length) > 0) {
        filteredData = filteredData.filter(function (row) {
          return filters.status.includes(row.status.toLowerCase());
        });
      }

      if (filters.search) {
        var searchText = filters.search.toLowerCase();
        filteredData = filteredData.filter(function (row) {
          return row.title.toLowerCase().includes(searchText);
        });
      }

      return {
        data: filteredData,
        total: filteredData.length
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPartialSuccess", function () {
      _this.setState({
        alertMessageType: 'error',
        alertMessage: "We're having some issues loading your campaign's metrics. We're currently working on a fix. Apologies for the inconvenience."
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hideAlertMessage", function () {
      _this.setState({
        alertMessageType: undefined,
        alertMessage: ''
      });
    });
    return _this;
  }

  (0, _createClass2.default)(EmailCampaignOverview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isProjectEnabled) {
        _axios.default.post('/emailCampaign/createProject');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isWebmasterConfigured = _this$props.isWebmasterConfigured,
          isProjectEnabled = _this$props.isProjectEnabled;
      var _this$state = this.state,
          alertMessageType = _this$state.alertMessageType,
          alertMessage = _this$state.alertMessage,
          hasExpiringCampaign = _this$state.hasExpiringCampaign;
      var otherProps = isProjectEnabled ? _objectSpread(_objectSpread({}, _utils.DYNAMIC_FETCHING_PARAMS), {}, {
        onPartialSuccess: this.onPartialSuccess
      }) : _utils.DISABLED_PROJECT_PARAMS;
      var stickyMessage = hasExpiringCampaign ? _utils.EXPIRING_CAMPAIGN_MESSAGE : _utils.STICKY_MESSAGE;
      return (0, _preact.h)("div", {
        className: "email-campaigns",
        "data-bounded-context": "Campaigns",
        "data-entity": "email-campaigns"
      }, (0, _preact.h)(_overview.default, (0, _extends2.default)({
        type: "email-campaign",
        headerTitle: "Email Campaigns",
        dataElementName: "Email Campaigns overview",
        dataTrackType: "click",
        withSearch: true,
        withFilters: getFilters(),
        searchPlaceholder: "Search email title",
        entity: "email-campaigns",
        bulkActions: [_RemoveCampaignAction.default],
        headerButtons: _utils.HEADER_BUTTONS,
        rowId: "id",
        model: getColumns(),
        areAppliedFiltersHiddenByDefault: true,
        clientSideFilter: this.clientSideFilter,
        hasStickyMessage: !isWebmasterConfigured || hasExpiringCampaign,
        stickyMessage: stickyMessage,
        stickyMessageVariant: hasExpiringCampaign ? 'warning' : 'info',
        EmptyStateComponent: (0, _preact.h)(_EmptyPage.default, {
          img_src: "".concat((0, _globals.default)('defaultCdn'), "/images/empty_page.png"),
          header: "There are no email campaigns yet",
          text: 'Seems like no one on your team has created an email campaign. \n Start now by creating one.',
          button: {
            link: '/email/new/email-campaign',
            text: 'Add email campaign'
          }
        })
      }, otherProps)), alertMessageType && (0, _preact.h)(_message.default, {
        isControl: true,
        variant: alertMessageType,
        onDismiss: this.hideAlertMessage,
        renderHTML: true,
        message: alertMessage
      }));
    }
  }]);
  return EmailCampaignOverview;
}(_preact.Component);

var _default = EmailCampaignOverview;
exports.default = _default;